export const CREDIT_CARD_ID = 'kk';
export const GOOGLE_PAY_ID = 'gp';
export const APPLE_PAY_ID = 'ap';
export const ADYEN_ID = 'ad';
export const KLARNA_ID = 'ks';
export const IDEAL_ID = 'id';

export const paymentMethods = [
    {
        name: 'creditCard',
        id: CREDIT_CARD_ID,
        imagePaths: [
            'fileadmin/images/Payment/Visa.png',
            'fileadmin/images/Payment/mc_symbol_opt_45_1x.png'
        ],
    },
    {
        name: 'googlePay',
        id: GOOGLE_PAY_ID,
        imagePaths: [
            'fileadmin/images/Payment/google-pay.svg'
        ],
    },
    {
        name: 'applePay',
        id: APPLE_PAY_ID,
        imagePaths: [
            'fileadmin/images/Payment/Apple_Pay_Mark_RGB.svg'
        ],
    },
    {
        name: 'klarna',
        id: KLARNA_ID,
        imagePaths: [
            'fileadmin/images/Payment/Klarna_marketing_badge.svg'
        ],
    },
    {
        name: 'iDeal',
        id: IDEAL_ID,
        imagePaths: [
            'fileadmin/images/Payment/Klarna_marketing_badge.svg'
        ],
    },
    {
        name: 'adyen',
        id: ADYEN_ID,
        imagePaths: [],
    }
];
